import { render } from "./Faq.vue?vue&type=template&id=d410c1ba&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=d410c1ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d410c1ba"

export default script